import { render, staticRenderFns } from "./VMinimalLayout.html?vue&type=template&id=6b33d0b1&scoped=true&external"
import script from "./VMinimalLayout.js?vue&type=script&lang=js&external"
export * from "./VMinimalLayout.js?vue&type=script&lang=js&external"
import style0 from "./VMinimalLayout.scss?vue&type=style&index=0&id=6b33d0b1&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33d0b1",
  null
  
)

export default component.exports